module.exports = __webpack_public_path__ + "img/galery27.96850f23.jpg";